import type { FC, PropsWithChildren, ReactNode } from 'react';
import cx from 'classnames';

import type { IconComponent } from '@motorway/mw-highway-code';
import { Icon } from '@motorway/mw-highway-code';

import styles from './ServiceHistoryInfoCards.module.scss';

interface ServiceHistoryInfoCardProps {
	filled?: boolean;
	icon: IconComponent;
	isHidden?: boolean;
	text: ReactNode;
}

export const ServiceHistoryInfoCard: FC<PropsWithChildren<ServiceHistoryInfoCardProps>> = ({
	children,
	filled,
	icon,
	isHidden,
	text,
}) => {
	return !isHidden ? (
		<div className={styles.item}>
			<Icon filled={filled}>{icon}</Icon>
			<span className={styles.stat}>{children}</span>
			<span className={cx(styles.text)}>{text}</span>
		</div>
	) : null;
};
